export default __webpack_public_path__ + "img/dTOTPTEN.291c1f23.svg";